<template>
  <div class="data-table">
    <h4 v-if="title!==''" style="text-align: center;font-size: 18px;font-weight: 400;">{{ title }}</h4>
    <div v-if="!doing" style="margin-bottom:10px">
      <el-row>
        <el-col v-if="radio === 1" :span="12" class="frequency" style="height:34px" />
        <el-col v-if="radio === 2" :span="12" class="frequency" style="height:34px" />
        <el-col v-if="radio === 3" :span="12" class="frequency" style="height:34px" />
        <el-col v-if="radio===1" :span="12" style="text-align:right;height:34px">
          <el-button v-if="isDownload&&update" v-table-toxls="views" plain :size="'small'" :file-name="'统计分析-按公司'"><svg-icon icon-class="export" />导出</el-button>
        </el-col>
        <el-col v-if="radio===2" :span="12" style="text-align:right;height:34px">
          <el-button v-if="isDownload&&update" v-table-toxls="views1" plain :size="'small'" :file-name="'统计分析-按招标方式'"><svg-icon icon-class="export" />导出</el-button>
        </el-col>
        <el-col v-if="radio===3" :span="12" style="text-align:right;height:34px">
          <el-button v-if="isDownload&&update" v-table-toxls="views2" plain :size="'small'" :file-name="'统计分析-按项目经理'"><svg-icon icon-class="export" />导出</el-button>
        </el-col>
      </el-row>
    </div>
    <div v-if="radio === 1" class="teble-div">
      <el-table
        v-if="!doing"
        id="views"
        v-loading="loading"
        :data="listData"
        border
        style="width: 100%"
        :span-method="spanMethod"
      >
        <el-table-column type="index" label="序号" width="45" align="center" />
        <el-table-column
          v-for="(option,optionKey) in listTb"
          :key="optionKey"
          :prop="option.prop"
          :label="option.title"
          :width="option.width"
          :align="option.align"
          :show-overflow-tooltip="true"
          :formatter="option.formatter"
        >
          <el-table-column
            v-for="(child,childKey) in option.child"
            :key="childKey"
            :prop="child.prop"
            :label="child.title"
            :width="child.width"
            :align="child.align"
            :show-overflow-tooltip="true"
            :formatter="child.formatter"
          />
        </el-table-column>
      </el-table>
      <div v-else class="empty-table">
        <span style="font-size:30px"><i class="el-icon-loading" /></span><br>
        <span style="font-size:15px">正在加载...</span>
      </div>
    </div>
    <div v-if="radio === 2" class="teble-div">
      <el-table
        v-if="!doing"
        id="views1"
        v-loading="loading"
        :data="listData"
        border
        style="width: 100%"
        :span-method="spanMethod"
      >
        <el-table-column type="index" label="序号" width="45" align="center" />
        <el-table-column
          v-for="(option,optionKey) in listTb1"
          :key="optionKey"
          :prop="option.prop"
          :label="option.title"
          :width="option.width"
          :align="option.align"
          :show-overflow-tooltip="true"
          :formatter="option.formatter"
        >
          <el-table-column
            v-for="(child,childKey) in option.child"
            :key="childKey"
            :prop="child.prop"
            :label="child.title"
            :width="child.width"
            :align="child.align"
            :show-overflow-tooltip="true"
            :formatter="child.formatter"
          />
        </el-table-column>
      </el-table>
      <div v-else class="empty-table">
        <span style="font-size:30px"><i class="el-icon-loading" /></span><br>
        <span style="font-size:15px">正在加载...</span>
      </div>
    </div>
    <div v-if="radio === 3" class="teble-div">
      <el-table
        v-if="!doing"
        id="views2"
        v-loading="loading"
        :data="listData"
        border
        style="width: 100%"
        :span-method="spanMethod"
      >
        <el-table-column type="index" label="序号" width="45" align="center" />
        <el-table-column
          v-for="(option,optionKey) in listTb2"
          :key="optionKey"
          :prop="option.prop"
          :label="option.title"
          :width="option.width"
          :align="option.align"
          :show-overflow-tooltip="true"
          :formatter="option.formatter"
        >
          <el-table-column
            v-for="(child,childKey) in option.child"
            :key="childKey"
            :prop="child.prop"
            :label="child.title"
            :width="child.width"
            :align="child.align"
            :show-overflow-tooltip="true"
            :formatter="child.formatter"
          />
        </el-table-column>
      </el-table>
      <div v-else class="empty-table">
        <span style="font-size:30px"><i class="el-icon-loading" /></span><br>
        <span style="font-size:15px">正在加载...</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    components: {},
    props: {
        title: { type: String, default: function() { return '' } },
        listTb: { type: Array, default: function() { return [] } }, // 列表头数组
        listTb1: { type: Array, default: function() { return [] } }, // 列表头数组
        listTb2: { type: Array, default: function() { return [] } }, // 列表头数组
        listData: { type: Array, default: function() { return [] } }, // 表格数据
        radio: { type: String, default: function() { return '' } }, // 第几个
        followNumTotal: { type: String, default: function() { return '' } }, // 跟进次数
        clueNumTotal: { type: String, default: function() { return '' } }, // 跟进线索次数
        customerNumTotal: { type: String, default: function() { return '' } }, // 跟进客户次数
        sellNumTotal: { type: String, default: function() { return '' } }, // 跟进商机次数
        contractNumTotal: { type: String, default: function() { return '' } }, // 跟进合同次数
        sellMoneyTotal: { type: String, default: function() { return '' } }, // 跟进合同次数
        possibleMoneyTotal: { type: String, default: function() { return '' } }, // 跟进合同次数
        clueNumTotal1: { type: String, default: function() { return '' } }, // 跟进合同次数
        customerNumTotal1: { type: String, default: function() { return '' } }, // 跟进合同次数
        sellNumTotal1: { type: String, default: function() { return '' } }, // 跟进合同次数
        contractNumTotal1: { type: String, default: function() { return '' } }, // 跟进合同次数
        sumText: { type: String, default: function() { return '合计' } }, // 合计标题
        showSummary: { type: Boolean, default: function() { return false } }, // 是否显示合计
        spanMethod: { type: Function, default: function() { return true } }, //
        tbToolbar: { type: Array, default: function() { return [{ val: '', name: '' }] } }, // 多表格切换按钮
        tbToolbarClick: { type: Function, default: function() { return true } }, // 表格切换点击事件
        // fileName: { type: String, default: function() { return '' } }, // 表格导出标题
        isDownload: { type: Boolean, default: function() { return true } }// 是否导出
    },
    data() {
        return {
            loading: true,
            toolbarVal: this.tbToolbar.length > 1 ? this.tbToolbar[0].val : '',
            lm: this.$route.meta,
            update: true,
            doing: true,
            fileName: ''
        }
    },
    watch: {
        toolbarVal(val) {
            this.update = false
            this.$nextTick(() => {
                this.update = true
            })
        },
        listTb(val) {
            this.doing = false
            setTimeout(() => {
                this.trandClass()
            }, 1000)
        },
        listTb1(val) {
            this.doing = false
            setTimeout(() => {
                this.trandClass()
            }, 1000)
        },
        listTb2(val) {
            this.doing = false
            setTimeout(() => {
                this.trandClass()
            }, 1000)
        },
        listData(val) {
            this.doing = false
        },
        radio(val) {
            this.doing = true
            setTimeout(() => {
                this.doing = false
            }, 100)
        }
    },
    created() {
        if (this.tbToolbar.length > 1) {
            this.tbToolbar.forEach(item => {
                if (item.val === this.toolbarVal) {
                    this.fileName = item.name
                }
            })
            this.update = false
            this.$nextTick(() => {
                this.update = true
            })
        }
    },
    mounted() {
        this.loading = false
    },
    methods: {
        trandClass() {
            const table = document.querySelector('.el-table__footer')
            if (table !== null) {
                const trs = table.querySelectorAll('.has-gutter tr')
                if (trs.length > 0) {
                    trs.forEach(tr => {
                        tr.className = 'el-table__row'
                    })
                }
            }
        },
        radioChange(val) {
            this.doing = true
            if (typeof this.tbToolbarClick === 'function') {
                this.tbToolbarClick(val)
            }
            if (this.tbToolbar.length > 1) {
                this.tbToolbar.forEach(item => {
                    if (item.val === val) {
                        this.fileName = item.name
                    }
                })
            }
        },
        // getSummaries(param) {
        //     const { columns, data } = param
        //     const sums = []
        //     columns.forEach((column, index) => {
        //         if (index === 0) {
        //             sums[index] = '合计'
        //             return
        //         }
        //         const values = data.map(item => Number(item[column.property]))
        //         if (!values.every(value => isNaN(value))) {
        //             sums[index] = values.reduce((prev, curr) => {
        //                 const value = Number(curr)
        //                 if (!isNaN(value)) {
        //                     return prev + curr
        //                 } else {
        //                     return prev
        //                 }
        //             }, 0)
        //             if (index === 2) {
        //                 sums[index] = '-'
        //             } else if (index === 1) {
        //                 sums[index] = '-'
        //             } else {
        //                 sums[index] = sums[index] + ''
        //             }
        //         } else {
        //             sums[index] = '-'
        //         }
        //     })
        //     return sums
        // },
        getSummaries2(param) {
            const { columns, data } = param
            const sums = []
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计'
                    return
                }
                const values = data.map(item => Number(item[column.property]))
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr)
                        if (!isNaN(value)) {
                            return prev + curr
                        } else {
                            return prev
                        }
                    }, 0)
                    if (index === 4) {
                        sums[index] = sums[index] + ''
                    } else if (index === 1) {
                        sums[index] = '-'
                    } else {
                        sums[index] = sums[index].toFixed(2)
                    }
                } else {
                    sums[index] = '-'
                }
            })
            return sums
        }
    }
}
</script>
<style lang="scss" scoped>
.data-table {
  .frequency{
    span{
      padding-right: 20px;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .teble-div{
    position: relative;
    .empty-table{
      position: absolute;
      top: 0;
      width: 100%;
      height: 1000%;
      text-align: center;
    }
  }
}
</style>
